<template>
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container-fluid headerStyle">
      <router-link class="navbar-brand" to="/"><img src="../assets/newABALogo.png" alt="ABA Logo" style="width:200px;"> </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <a>{{ formattedDate }}</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
    
</template>

<script>
    import { format } from 'date-fns';

    export default {
        data() {
            return {
            formattedDate: ''
            };
        },
        created() {
            this.formattedDate = this.getCurrentFormattedDate();
        },
        methods: {
            getCurrentFormattedDate() {
            return format(new Date(), 'MMMM dd, yyyy HH:mm:ss');
            }
        }
    };
</script>

<style scoped>
.navbar {
    background-color: #0079b4;
    color: rgb(255, 255, 255);
    font-weight: 700;
    height: 52px;
    font-size: 12px;
    font: 'Arial';
}

#navbar li{
  color: rgb(255, 255, 255);
}

.headerStyle{
  background-color: #0079b4;
  color: rgb(255, 255, 255);
}

.navbar-toggler-icon{
    display:none;
}
</style>